import { injectable } from 'inversify';
import { makeAutoObservable } from 'mobx';

import { KomplyanceAiGetConversationsListItem } from '@libs/types';

@injectable()
export class ConversationsHistoryStore {
  currentConversation: KomplyanceAiGetConversationsListItem | null = null;
  searchTerm = '';
  constructor() {
    makeAutoObservable(this);
  }

  get selectedConversationId() {
    return this.currentConversation?.id;
  }

  selectConversation(conversation: KomplyanceAiGetConversationsListItem) {
    this.currentConversation = conversation;
  }

  deselectConversation() {
    this.currentConversation = null;
  }

  setSearchTerm(searchTerm: string) {
    this.searchTerm = searchTerm;
  }
}
